<!--// TODO: create generic component -->
<div class="portlet box brand">
  <div class="portlet-title">
    <div class="caption">
      <i class="fa fa-search" aria-hidden="true"></i>
      <span *ngIf="showSearchForm">{{ 'GENERIC_FILTER' | translate:locale.language }}</span>
    </div>
    <div *ngIf="!showSearchForm" [@fade]="!showSearchForm" class="quick-search">
      <form [formGroup]="quickSearchForm" novalidate>
        <div class="btn-group">
          <input type="text" class="form-control" formControlName="quickSearch"
                 id="GENERIC_QUICK_SEARCH"
                 autocomplete="off"
                 [placeholder]="'GENERIC_QUICK_SEARCH' | translate:locale.language">
          <span *ngIf="showResetQuickSearch()" [@fade]="showResetQuickSearch()" class="fa fa-times clear-search"
                (click)="resetQuickSearch($event)"></span>
        </div>
      </form>
    </div>
    <div class="tools">
      <a href="#" [title]="'EXPANDER_TITLE' | translate:locale.language"
         (click)="toggleSearchForm($event)" [class.collapse]="showSearchForm" [class.expand]="!showSearchForm"> </a>
    </div>
  </div>
  <div class="portlet-body form" *ngIf="showSearchForm" [@slide]="showSearchForm">
    <form class="form-horizontal" [formGroup]="searchForm" (submit)="applyFilter(searchForm.value)" novalidate>
      <div class="form-body">
        <div class="row">
          <div class="col-sm-12 datepickerFilter link_box">
            <storever-dynamic-form [config]="formConfig.config" [form]="searchForm" [stylingClass]="'dynamic-form-list'"></storever-dynamic-form>
          </div>
        </div>
      </div>
      <div *ngIf="false" style="display:flex;">
        <pre style="flex:1">{{searchForm.value | json}}</pre>
      </div>
      <div class="form-actions">
        <div class="row">
          <div class="col-sm-12 footer-content">
            <button type="button" class="btn brand btn-outline" (click)="resetFilter($event)" id="GENERIC_FILTER_REST_BTN">
              {{'GENERIC_RESET' | translate:locale.language}}
            </button>
            <button type="submit" class="btn brand" id="GENERIC_FILTER_SEARCH_BTN">{{'GENERIC_SEARCH' | translate:locale.language}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

